// generated by srcset-codegen
import src from "./postalfun-marketing-screenshot.png";
import src2x from "./postalfun-marketing-screenshot@2x.png";
import src3x from "./postalfun-marketing-screenshot@3x.png";

const width = 679;
const height = 789;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
